import Icon from '../components/Icon.vue'

Icon.register({
  frown: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM338.2 394.2c13.5 16.3 38.1-4.2 24.5-20.4-28.4-34.2-70.3-53.8-114.7-53.8s-86.3 19.6-114.8 53.7c-13.5 16.3 11.1 36.8 24.6 20.5 22.4-26.8 55.3-42.2 90.2-42.2s67.8 15.4 90.2 42.2z'
      }
    ]
  }
})
